'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _configs = require('./configs');

var _makeCanvas = require('./make-canvas');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExifRotate = function () {
  function ExifRotate() {
    _classCallCheck(this, ExifRotate);
  }

  _createClass(ExifRotate, null, [{
    key: 'showPreviewImage',

    /**
    *  @param img {elem}
    *  @param options {object}
    */
    value: function showPreviewImage(files) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      (0, _makeCanvas.init)(files, options).then(function (canvas) {
        for (var i = 0; i < canvas.length; i += 1) {
          var base_64 = canvas[i].toDataURL('image/jpeg');
          var new_img = new Image();
          new_img.setAttribute('src', base_64);
          var id = options.container_id ? options.container_id : _configs.default_container_id;
          var container = document.getElementById(id);
          container.appendChild(new_img);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }

    /**
    *  @param img {elem}
    *  @param options {object}
    *  @return base 64 data url {string}
    */

  }, {
    key: 'getBase64String',
    value: function getBase64String(files) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments[2];

      (0, _makeCanvas.init)(files, options).then(function (canvas) {
        for (var i = 0; i < canvas.length; i += 1) {
          callback(canvas[i].toDataURL('image/jpeg'));
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }]);

  return ExifRotate;
}();

exports.default = ExifRotate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/exif-rotate-js/lib/exif-rotate.js
// module id = 915
// module chunks = 0